import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ice px-4 py-5 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hdun8f7zex85">
        <h2 className="text-center font-heading text-lg font-extrabold uppercase text-deep sm:text-3xl" data-id="element-43" data-mp="1ceqefpoyz1ic">
          Frequently asked questions
        </h2>
        <div className="mt-3 divide-y divide-clinical/10 overflow-hidden rounded-xl bg-white shadow-sm" data-id="element-44" data-mp="2a1h0kf70hg87">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-45" data-mp="20280r5pgt7dx" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" data-id="element-46" data-mp="1v583nkalfeyy">
                  <span className="font-heading text-[0.84rem] font-bold text-deep sm:text-base" data-id="element-47" data-mp="jrx6ond5x1yu">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-turq transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="1pls1e1uhffdd" />
                </button>
                {isOpen ? <p className="px-3 pb-2.5 text-[0.86rem] leading-snug text-muted sm:text-base" data-id="element-49" data-mp="11vo0w3clbvql">
                    {faq.a}
                  </p> : null}
              </div>;
        })}
        </div>
      </div>
    </section>;
}